import { render, staticRenderFns } from "./editRule.vue?vue&type=template&id=51a0f140&scoped=true&"
import script from "./editRule.vue?vue&type=script&lang=js&"
export * from "./editRule.vue?vue&type=script&lang=js&"
import style0 from "./editRule.vue?vue&type=style&index=0&id=51a0f140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0f140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a0f140')) {
      api.createRecord('51a0f140', component.options)
    } else {
      api.reload('51a0f140', component.options)
    }
    module.hot.accept("./editRule.vue?vue&type=template&id=51a0f140&scoped=true&", function () {
      api.rerender('51a0f140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/editRule.vue"
export default component.exports